export default __webpack_public_path__ + "static/media/third-anniversary.985ae702.svg";